import { Box, TextField } from '@mui/material';
import { TextSpan } from '../../../Atoms/Text';
import { DISCOVERY_TEXT_LIMIT } from './discoveryLimits';

interface DiscoveryNotesBoxProps {
  value: string;
  // Names the box for screen readers; a notes-type question passes its own label.
  label?: string;
  onChange: (notes: string) => void;
}

export const DiscoveryNotesBox = ({ value, label = 'Notes', onChange }: DiscoveryNotesBoxProps) => (
  <Box>
    <TextSpan
      size="xs"
      weight="medium"
      color="grey6"
      className="inline-block rounded-full bg-grey-1 px-2 py-0.5 mb-1">
      Notes
    </TextSpan>
    <TextField
      fullWidth
      multiline
      minRows={2}
      size="small"
      value={value}
      placeholder="Optional follow-up notes…"
      inputProps={{ 'aria-label': label, maxLength: DISCOVERY_TEXT_LIMIT }}
      onChange={(event) => onChange(event.target.value)}
    />
  </Box>
);
